module.exports = __webpack_public_path__ + "img/Apple.00a9add5.jpg";